import assetPath from '/app/packages/lebenslauf/articles/src/assets/probezeit.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')